import Navbar from "./partials/navbar";
import Footer from "./partials/footer";
import {useEffect} from "react";

export default function MainLayout( {children} ) {
  useEffect(() => {
    document.body.setAttribute("data-layout", "topnav");
    document.body.setAttribute("data-bs-theme", "light");
    document.body.setAttribute("data-layout-mode", "fluid");
    document.body.setAttribute("data-topbar-color", "dark");
    document.body.setAttribute("data-sidenav-size", "default");
    document.body.setAttribute("data-layout-position", "fixed");
    //document.documentElement.setAttribute("data-layout", "topnav");
  }, []);

  return (
    <>
      <div className={"wrapper"}>
        <div className={"content-page"}>
          <div className={"content pb-5"}>
            <Navbar />
            <main>
              { children }
            </main>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}
